import { render } from "./loginSet.vue?vue&type=template&id=4e11595a&scoped=true"
import script from "./loginSet.vue?vue&type=script&lang=js"
export * from "./loginSet.vue?vue&type=script&lang=js"

import "./loginSet.vue?vue&type=style&index=0&id=4e11595a&lang=less&scoped=true"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e11595a"]])

export default __exports__